module.exports = __webpack_public_path__ + "static/media/HomePage-item1.fdabf09c.webp";